import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { useTranslation } from 'react-i18next';

const TwoFactorSetup = ({onSuccess, onCancel}) => {
  const { t } = useTranslation();
  const [qrCode, setQrCode] = useState(null);
  const [secret, setSecret] = useState('');
  const [code, setCode] = useState('');
  const [backupCodes, setBackupCodes] = useState([]);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';


  // 1️⃣ Récupérer QR code + secret
  useEffect(() => {
    const fetchQrCode = async () => {
      try {
        const response = await api.get('/api/users/2fa/setup');
        setQrCode(response.data.qrCodeDataURL);
        setSecret(response.data.manualKey);
      } catch (err) {
        console.error(err);
        setError(t('2fa.erreur_setup'));
      }
    };
    fetchQrCode();
  }, []);

  // 2️⃣ Valider le code saisi
  const handleVerify = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!code || code.length !== 6) {
      setError(t('2fa.code_invalide'));
      return;
    }
    setLoading(true);
    try {
      const response = await api.post('/api/users/2fa/verify-setup', { code });
      setBackupCodes(response.data.backupCodes); // afficher à l’utilisateur
      setSuccess(t('2fa.activation_reussie'));
// 🔑 INFORMER LE PARENT
if (onSuccess && response.data.user) {
  const currentUser = JSON.parse(localStorage.getItem('user') || '{}');
  const mergedUser = {
    ...currentUser,
    ...response.data.user,
    twoFactor: response.data.user.twoFactor
  };
  onSuccess(mergedUser);
}

    } catch (err) {
      const backendCode = err.response?.data?.code;
      setError(backendCode ? t(backendCode) : t('2fa.erreur_activation'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="two-factor-setup">
      <h2>{t('2fa.activer')}</h2>

      {error && <p className="error">{error}</p>}
      {success && <p className="success">{success}</p>}

      {qrCode && !success && (
        <div>
          <p>{t('2fa.scanner_qr')}</p>
          <img src={qrCode} alt="QR code Google Authenticator" />
         
	<p>
 	 {t('2fa.mobile_hint')}
	</p>
	<p>
	 <code className="hint">{secret}</code>
	</p>
	<p>
    <strong>{t('2fa.secret_secondaire')} :</strong>
   
  	</p>

          <form onSubmit={handleVerify}>
            <input
className="verifyinput"
  type="text"
  inputMode="numeric"
  pattern="[0-9]*"
  maxLength="6"
  value={code}
  onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
  placeholder={t('2fa.saisir_code')} // ex : "Code à 6 chiffres"
  autoFocus
/>

            <button type="submit" className="btn-primary" disabled={loading}>{t('2fa.valider')}</button>
          </form>
        </div>
      )}

      {backupCodes.length > 0 && (
        <div>
          <h3>{t('2fa.codes_secours')}</h3>
          <ul>
            {backupCodes.map((c, idx) => (
              <li key={idx}>{c}</li>
            ))}
          </ul>
          <p>{t('2fa.conserver_codes')}</p>
<button onClick={onCancel}>
      {t('2fa.terminer')}
    </button>
        </div>
      )}
    </div>
  );
};

export default TwoFactorSetup;
